import Abdulmalik from "../images/abdulmalik.jpg";
import Favour from "../images/favour.jpg";
import Khalifa from "../images/khalifa.jpg";
import Mololuwa from "../images/mololuwa.jpg";
import Shaibu from "../images/shaibu.jpg";

var AboutUsData = [
  {
    id: 1,
    img: Abdulmalik,
    name: "ABDULMALIK ADEYEMO",
    title: "CEO & Founder",
    descriptionOne:
      "Abdulmalik Adeyemo is a machine learning researcher focused on the application of cutting-edge Machine Learning and Artificial Intelligence techniques to concrete problems in healthcare.",
    descriptionTwo:
      "He earned a First Class Bachelor's degree in Computer Engineering from the University of Ilorin and was branded the department's best graduating student.",
    descriptionThree:
      "He is actively involved in the use of artificial intelligence to improve healthcare service and delivery in Africa. He has worked on several AI in healthcare projects, including AI-assisted chest X-ray diagnosis, brain tumor detection from MRI scans, and Diabetic Retinopathy detection from fundus images.",
   
  },
  {
    id: 2,
    img: Favour,
    name: "FAVOUR UDOFIAH",
    title: "CFO & Co-founder",
    descriptionOne:
      "Favour Udofiah Imabasi is a Data Science enthusiast with active involvement in innovatively disrupting the norms with AI technology",
    descriptionTwo:
      "She is a Data scientist leveraging machine learning to help create IT solutions, recycle data, build machine learning and deep learning models for the purpose of efficient prediction and recommendations as well as analysis.",
    descriptionThree:
      "She is a Computer Science undergraduate at the Federal university of technology Owerri",
   
  },
  {
    id: 3,
    img: Khalifa,
    name: "KHALIFA SHU’AIB",
    title: "CTO & Co-founder",
    descriptionOne:
      "As a student of mechatronics engineering, Khalifa has a flair for all things tech and possesses key interest in automation of processes using Robotics and Artificial Intelligence.",
    descriptionTwo:
      " Having years of experience as a computer-aided designer, he’s also able to bring to life many of his innovative ideas.",
    descriptionThree:
      " Khalifa currently serves as the president of the Nigerian Universities’ Engineering Students Association (NUESA): Afe-Babalola University Chapter and is deep into research for solutions to insecurity in Nigeria using locally made Unmanned Aerial Vehicles for Intelligence, surveillance and reconnaissance.",
   
  },
  {
    id: 4,
    img: Mololuwa,
    name: "MOLOLUWA ADENIYI",
    title: "COO & Co-founder",
    descriptionOne:
      "Mololuwa Adeniyi is a robotics engineer, skilled in Web 3.0 development with the goal of utilizing the technology to create real life solutions. ",
    descriptionTwo:
      " He has a strong background in Mechatronics Engineering and automation, creating easy and efficient ways to solve global and local challenges.",
    descriptionThree:
      "He is also a blockchain developer at the lzyutesclub a community based project centered around leveraging technology and creativity to provide a platform for youths in Nigeria to thrive.",
   
  },

  {
    id: 5,
    img: Shaibu,
    name: "DR. SHAIBU JEMILA ITOSIME OD",
    title: "Optometrist | Domain Expert | Founder of JIVAS",
    descriptionOne:
      "Dr. Shaibu Jemila Itsosime OD. is a practicing optometrist forged with 5 years of experience. First as an intern at Davik Eye Clinic in 2020, then a Corp Optometrist at National Hospital, Abuja, and currently as a Regional Manager at Eyemasters, Utako.",
    descriptionTwo:
      "Her tenacity, brilliance, and resilience earned her an early promotion to her current role from her entry role as a Practice Manager in May 2022. She is known to be a self-motivated professional, innovative thinker, patient’s favorite, and great team-player. Qualities which make her worthy of the station she currently holds.",
    descriptionThree:
      "Being an advocate for self-development, Dr. Jemila is a budding scholar of Physiological Optics, Environmental Vision, Contact Lens, and Geriatric Optometry.",
   
  },
];

export default AboutUsData;
